import { render } from "./HeaderTab.vue?vue&type=template&id=09e8066b&scoped=true"
import script from "./HeaderTab.vue?vue&type=script&lang=js"
export * from "./HeaderTab.vue?vue&type=script&lang=js"

import "./HeaderTab.vue?vue&type=style&index=0&id=09e8066b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e8066b"]])

export default __exports__